import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NextAvailableSlot = ({ serviceName }) => {
  const [nextSlot, setNextSlot] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNextAvailable();
  }, [serviceName]);

  const fetchNextAvailable = async () => {
    try {
      // Get tomorrow's date
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const startDate = tomorrow.toISOString().split('T')[0];

      // Fetch availability (using practitioner ID 1 as default - can be made dynamic)
      const response = await fetch(
        `${BACKEND_URL}/api/dentally/availability?start_date=${startDate}&practitioner_ids=1&duration_minutes=30`
      );
      
      const data = await response.json();
      
      if (data.success && data.slots && data.slots.length > 0) {
        // Get the first available slot
        const firstSlot = data.slots[0];
        const slotTime = new Date(firstSlot.start_time);
        
        setNextSlot({
          date: slotTime.toLocaleDateString('en-GB', { 
            weekday: 'short', 
            day: 'numeric', 
            month: 'short' 
          }),
          time: slotTime.toLocaleTimeString('en-GB', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })
        });
      } else {
        setNextSlot(null);
      }
    } catch (error) {
      console.error('Error fetching next available slot:', error);
      setNextSlot(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-chocolate-malt animate-pulse">
        <Calendar className="w-4 h-4" />
        <span>Checking availability...</span>
      </div>
    );
  }

  if (!nextSlot) {
    return (
      <div className="flex items-center gap-2 text-sm text-chocolate-malt">
        <Calendar className="w-4 h-4" />
        <span>Call to check availability</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      <Calendar className="w-4 h-4 text-burnt-coral" />
      <span className="text-chocolate-malt">
        Next available: <span className="font-semibold text-rabbit">{nextSlot.date} at {nextSlot.time}</span>
      </span>
    </div>
  );
};

export default NextAvailableSlot;
